import installInfoGrid from './config';

export default installInfoGrid;
